var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-tab-left",
    clipPath: "url(#clip0_2698_1860)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58468 0 0 3.58468 0 8C0 12.4153 3.58468 16 8 16C12.4153 16 16 12.4153 16 8C16 3.58468 12.4153 0 8 0ZM8 1.06667C11.8267 1.06667 14.9333 4.17331 14.9333 8C14.9333 11.8267 11.8267 14.9333 8 14.9333C4.17331 14.9333 1.06667 11.8267 1.06667 8C1.06667 4.17331 4.17331 1.06667 8 1.06667ZM7.46667 3.73333V8C7.46667 8.14133 7.52267 8.27733 7.62267 8.37733L9.756 10.5107C9.96401 10.7187 10.302 10.7187 10.51 10.5107C10.718 10.3027 10.718 9.96466 10.51 9.75665L8.53266 7.77931V3.73332C8.53266 3.43864 8.294 3.19998 7.99933 3.19998C7.70465 3.19998 7.46599 3.43864 7.46599 3.73332L7.46667 3.73333Z",
    fill: "#B59800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2698_1860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.cfa8301c2a09f9debb2ebaa49c0c69af.svg";
export { ForwardRef as ReactComponent };